import React from 'react';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import PropTypes from 'prop-types';
import InstrumentLookup from '../Instrument/InstrumentLookup';

const handleOnChange = (option, isSecure) => {
    const instrumentId = option?.value?.instrumentId?.replace('.', '-').toLowerCase();

    if (isSecure) {
        window.location = `${window.location.origin}/secure/markets/${instrumentId}`;
        return;
    }

    window.location = `${window.location.origin}/markets/${instrumentId}`;
};

const MarketsLookup = ({ isSecure }) => (
    <InstrumentLookup
        handleOnChange={(option) => handleOnChange(option, isSecure)}
        placeholderText={'Enter Search'}
        isDisabled={false}
        showSearchIcon={true}
    />
);

MarketsLookup.propTypes = {
    isSecure: PropTypes.bool,
};

MarketsLookup.defaultProps = {
    isSecure: false,
};

export default MarketsLookup;
